import { Spin } from "antd";

type LoadingBlockerProps = {
  readonly loading: boolean;
};

export const LoadingBlocker = ({ loading }: LoadingBlockerProps) => {
  return <Spin delay={1000} fullscreen spinning={loading} />;
};
